import React, { useEffect, useState, useRef } from "react";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken";
import getTemporaryUrl from "../api/getTemporaryUrl";
import { getDocDataById } from "../models/DataFunctions";
import downloadFile from "../api/download/downloadFile";
import SmallSpinner from "../loading/SmallSpinner";
import PDF from "../pdf/PDF";
import TextField2 from "../textfields/TextField2";
import Space from "../layout/Space";
import Dropzone2 from "../dropzones/DropZone2";
import uploadDropZoneTemporary from "../api/upload/uploadDropZoneTemporary";

import transferFolderFiles from "../api/folder/transferFolderFiles";
import { isValidUrl } from "../sign/HS2";
import Icon1 from "../icons/Icon";

import sign from "../api/sign/sign";
import { getDocument } from "pdfjs-dist";
import PdfViewer from "../sign/model/PdfViewer";

import sendGuestText from "../api/sign/sendGuestText";
import Tippy from "@tippyjs/react";
import { check_files_are_all_zip_or_xml } from "../pages/folder_pages/FolderV2";

const SignBlockFolder = ({
  id,
  orgData,
  folderData,
  clientData,
  prefix,
  block,
  setBlock,
  blocks,
  setBlocks,
  handleClickVariant,
  fetchFiles,
  onRefresh,
  setHideSideWidgets,
  particulier = false,
  impersonate = false,
}) => {
  const [fileName, setSelectedFileName] = useState(null);
  const [consentGiven, setConsentGiven] = useState(true);
  const handleSetFastSign = async (block) => {
    setLoadingConfirm(true);
    setHideSideWidgets(true);
    try {
      const token = await getOrRefreshFirebaseToken();
      await getTemporaryUrl(token, "all", "", id, prefix);

      let doc = await getDocDataById("document", block.id);
      block.files = doc.files;
      let new_blocks = blocks.map((b) => {
        if (b.id === block.id) {
          return block;
        } else {
          return b;
        }
      });
      setSelectedFileUrl(block.files[0].url);
      setSelectedFileName(block.files[0].name);
      setBlocks(new_blocks);

      setSignType("inside");
      setSignStep(1);
    } catch (error) {
      console.error("Error setting fast sign:", error);
    }
    setLoadingConfirm(false);
  };

  useEffect(() => {
    handleFetchData();
  }, [block]);

  const handleFetchData = async () => {
    setChamps(block.champs || []);
    // reset everything
    setSignStep(0);
    setSignType("");
    setTamponUrl("");
    setSignUrl("");
    setSignName("");
    setConsentGiven(true);
    setSelectedFileUrl(null);
    setSelectedFileName(null);
    setDroppedFiles([]);
    setDroppedExists(false);
  };

  const handleDownloadSign = async (block) => {
    const token = await getOrRefreshFirebaseToken();
    await getTemporaryUrl(token, "all", "", id, prefix);
    let doc = await getDocDataById("document", block.id);
    downloadFile(doc.files[0]);
    setSignStep(2);
  };
  const [sign_step, setSignStep] = useState(0);
  const [sign_type, setSignType] = useState("");
  const [loadingConfirm, setLoadingConfirm] = useState(false);
  const [loading_drop, setLoadingDrop] = useState(false);

  const [marques_options, setMarquesOptions] = useState([]);
  const [marques, setMarques] = useState([]);
  const [marque, setMarque] = useState("");
  const [tampon_url, setTamponUrl] = useState("");
  const [sign_url, setSignUrl] = useState("");
  const [champs, setChamps] = useState([]);
  const [dropped_files, setDroppedFiles] = useState([]);
  const [dropped_exists, setDroppedExists] = useState(false);
  const pdfContainerRef = useRef(null); // Reference to the PDF container
  const [sign_name, setSignName] = useState("");

  const transferFiles = async (document_id) => {
    try {
      setLoadingConfirm(true);
      const token = await getOrRefreshFirebaseToken();
      if (document_id === "xml") {
        let correct = check_files_are_all_zip_or_xml();
        if (!correct) {
          handleClickVariant(
            "Les fichiers doivent être au format .zip",
            "error"
          );
          return;
        }
      }
      if (document_id === "mo") {
        let correct = check_files_are_all_zip_or_xml();
        if (!correct) {
          handleClickVariant(
            "Les fichiers doivent être au format .zip",
            "error"
          );
          return;
        }
      }
      await transferFolderFiles(document_id, id, dropped_files, token, prefix);

      await fetchFiles();
      setDroppedFiles([]);
      setDroppedExists(false);
      onRefresh();
      setLoadingConfirm(false);
    } catch (error) {
      console.error("Error transferring files:", error);
      setLoadingConfirm(false);
    }
  };

  const handleFetchMarques = async () => {
    try {
      if (
        folderData.client_type !== "particulier" &&
        clientData.marques &&
        clientData.marques.length > 0
      ) {
        const marques_options = clientData.marques.map((marque) => {
          return { value: marque.name, label: marque.name };
        });
        setMarques(clientData.marques);
        setMarquesOptions(marques_options);
      } else {
        setMarques([]);
        setMarquesOptions([]);
      }
    } catch (error) {
      console.error("Error fetching marques:", error);
    }
  };

  useEffect(() => {
    handleFetchMarques();
  }, [clientData]);

  const textRef = useRef();

  const onDelete = (file) => {
    const new_files = dropped_files?.filter((f) => f !== file);
    setDroppedFiles(new_files);
    if (new_files.length === 0) {
      setDroppedExists(false);
    }
  };

  const handleSetFieldValue = (champ, e) => {
    let new_champs = [...champs];
    let new_champ = { ...champ };
    new_champ.content = e.target.value;
    new_champs = new_champs.map((ch) => {
      if (ch.label === champ.label) {
        return new_champ;
      } else {
        return ch;
      }
    });

    setChamps(new_champs || []);
  };

  const onDropZone = async (files) => {
    setLoadingDrop(true);
    const token = await getOrRefreshFirebaseToken();

    let new_files = [];

    new_files = files.filter(
      (file) => !dropped_files.map((filed) => filed.name).includes(file.name)
    );

    let new_drop_files = [];

    for (let i = 0; i < new_files.length; i++) {
      let res = await uploadDropZoneTemporary(
        token,
        new_files[i],
        new_files[i].name,
        prefix
      );
      let url = res.url;
      let name = res.name;
      let size = new_files[i].size;
      new_drop_files = [
        ...new_drop_files,
        { url: url, name: name, size: size },
      ];
    }
    let new_dropped_files = [...dropped_files, ...new_drop_files];
    setDroppedFiles(new_dropped_files);
    setDroppedExists(true);

    setLoadingDrop(false);
  };

  const [selectedFileUrl, setSelectedFileUrl] = useState(null);
  const [pdfDimensions, setPdfDimensions] = useState({ width: 0, height: 0 });

  const handlePdfLoad = async () => {
    if (!selectedFileUrl) {
      // check if the selected file is a PDF
      if (!selectedFileUrl.includes(".pdf")) {
        console.error("The selected file is not a PDF");
        return;
      } else {
        console.error("The selected file is a PDF");
      }

      try {
        const loadingTask = getDocument(selectedFileUrl);

        // Wait for the PDF to be loaded
        const pdf = await loadingTask.promise;
      } catch (error) {
        console.error("Error loading PDF:", error.message);
      }
      // Get the total number of pages
      const numPages = pdf.numPages;

      const container = pdfContainerRef.current;

      if (container) {
        const totalHeightInCssPixels = container.scrollHeight; // This gives the total scrollable height in CSS pixels

        // Calculate the height per page in CSS pixels
        const pageHeightInCssPixels = totalHeightInCssPixels / numPages;

        // You can also update state to store these values
        setPdfDimensions({
          width: container.clientWidth, // Use the width of the container in CSS pixels
          height: pageHeightInCssPixels, // Set the per-page height in CSS pixels
        });
      }
    }
  };

  const handleSign = async () => {
    let new_champs = [...champs];
    if (particulier) {
      if (particulier && sign_name === "") {
        handleClickVariant(
          "Veuillez ajouter un nom pour la signature",
          "error"
        );
        return;
      }
      if (particulier && sign_name.length > 6) {
        handleClickVariant(
          "Les initiales ne doivent pas dépasser 6 caractères",
          "error"
        );
        return;
      }
      if (particulier) {
        const token = await getOrRefreshFirebaseToken();
        const img_url = await sendGuestText(sign_name, token, prefix);
        setSignUrl(img_url);

        new_champs = fillAutoSign(champs, img_url);
      }
    }

    if (!particulier && !marque) {
      handleClickVariant("Veuillez choisir une marque", "error");
      return;
    }

    if (!particulier) {
      new_champs = fillAutoSign(champs, sign_url, tampon_url);
    }

    setLoadingConfirm(true);
    setHideSideWidgets(false);
    try {
      const url = selectedFileUrl;
      const { width, height } = pdfDimensions;
      const token = await getOrRefreshFirebaseToken();
      const folderId = id;
      await sign(
        new_champs,
        height,
        width,
        url,
        token,
        folderId,
        block.id,
        impersonate ? "impersonate" : null,
        prefix,
        fileName,
        block.name === "Formulaire consentement DPE",
        consentGiven
      );
      handleClickVariant("Attestation signée avec succès", "success");
      onRefresh();
    } catch (error) {
      handleClickVariant(
        "Une erreur s'est produite. Merci de réessayer ultérieurement.",
        "error"
      );
      console.error("Error signing:", error);
    }
    setLoadingConfirm(false);
  };

  const fillAutoSign = (champs, autosign = null, autotampon = null) => {
    for (let champ of champs) {
      if (champ.type === "Signature" && autosign != null) {
        if (autosign !== "") {
          champ.content = autosign;
          if (isValidUrl(autosign)) {
            champ.imgPath = autosign;
          }
        }
      }
      if (champ.type === "Tampon" && autotampon != null) {
        if (autotampon !== "") {
          champ.content = autotampon;
          if (isValidUrl(autotampon)) {
            champ.imgPath = autotampon;
          }
        }
      }
    }

    // set the modified list of champs
    // srt block
    // remove all Tampon
    if (autotampon === null) {
      champs = champs.filter((champ) => champ.type !== "Tampon");
    }

    return champs;
  };

  return (
    <div className="flex flex-col  h-fit w-full px-4">
      {sign_step !== 0 && (
        <BackButton
          setSignStep={setSignStep}
          sign_type={sign_type}
        ></BackButton>
      )}

      {sign_step === 0 && (
        <div className="w-full mb-5 justify-center h-fit flex flex-row gap-4 mt-4 items-center">
          {!particulier && (
            <div
              className={`flex border-2 border-primary text-primary h-fit rounded-full w-fit   px-10 py-3  font-medium
           bg-white  cursor-pointer hover:shadow-lg`}
              onClick={() => {
                setSignType("outside");
                setSignStep(1);
              }}
            >
              Signature hors hexagone
            </div>
          )}

          <div
            className={`flex items-center rounded-full w-fit   px-10 py-3 text-white font-medium
           bg-primary  cursor-pointer hover:shadow-lg`}
            onClick={() => handleSetFastSign(block)}
          >
            Signature rapide{" "}
            <SmallSpinner margin={6} loading={loadingConfirm} size={25} />
          </div>
        </div>
      )}
      {sign_step === 1 && sign_type === "outside" && (
        <div className="w-full mb-5 justify-center h-fit flex flex-col gap-4 mt-4 items-center">
          <div className="w-full mb-5 justify-center flex flex-row gap-4 mt-4 items-center">
            <div
              className={`flex  rounded-full w-fit   px-10 py-3 text-white font-medium
           bg-primary  cursor-pointer hover:shadow-lg`}
              onClick={() => handleDownloadSign(block)}
            >
              Télécharger le document vierge
            </div>
          </div>
        </div>
      )}
      {sign_step === 2 && sign_type === "outside" && (
        <div className="w-full mb-5 h-fit justify-center flex flex-col gap-4 mt-4 items-center">
          <Dropzone2
            onDrop={onDropZone}
            files={dropped_files || []}
            onDelete={onDelete}
            loading={loading_drop}
          ></Dropzone2>
          <div className="w-full justify-center flex flex-row ">
            <div
              className={`flex  rounded-full w-fit   px-6 py-2 text-white font-medium
                  ${dropped_files.length === 0 ? "bg-gray-300" : " bg-primary  cursor-pointer hover:shadow-lg"}`}
              onClick={() => {
                dropped_files.length !== 0 ? transferFiles(block.id) : {};
              }}
            >
              Confirmer
              <SmallSpinner margin={6} loading={loadingConfirm} />
            </div>
          </div>
        </div>
      )}
      {sign_step === 1 && sign_type === "inside" && (
        <div className="w-full mb-5 h-fit justify-center flex flex-col gap-4 my-4 items-center">
          <div className="w-full  justify-center flex flex-col gap-6 items-center h-c500 ">
            {block.files && block.files.length > 0 && (
              <div
                id="pdf-container"
                ref={pdfContainerRef} // Assign the container ref here
                style={{
                  width: "100%",
                  height: "100%",
                  overflowY: "auto",
                }}
              >
                <div
                  style={{
                    position: "relative",
                    width: "100%",
                    height: "100%",
                  }}
                >
                  <PdfViewer
                    pdfFile={selectedFileUrl}
                    onPdfLoad={handlePdfLoad}
                  ></PdfViewer>
                </div>
              </div>
            )}
            {block.files && block.files.length === 0 && (
              <div className="text-h2 font-semibold">
                Aucun document à signer
              </div>
            )}
          </div>
          <div
            className={`flex  rounded-full w-fit h-fit  px-10 py-3 text-white font-medium
               bg-primary  cursor-pointer hover:shadow-lg`}
            onClick={() => {
              if (
                champs.filter(
                  (champ) =>
                    champ.type !== "Signature" && champ.type !== "Tampon"
                ).length === 0
              ) {
                setSignStep(3);
              } else {
                setSignStep(2);
              }
            }}
          >
            Suivant
          </div>
        </div>
      )}
      {sign_step === 2 && sign_type === "inside" && (
        <div className="w-full mb-5 h-fit justify-center flex flex-col gap-4 my-4 items-center">
          <div className="text-shadow_50 text-h2 font-semibold">
            Complétez les champs suivants
          </div>
          <div className="flex flex-col w-full gap-2 items-center p-2">
            {champs

              .filter(
                (champ) => champ.type !== "Signature" && champ.type !== "Tampon"
              )
              .map((champ, index) => (
                <div className="flex flex-row w-c400" key={index}>
                  <TextField2
                    value={champ.content}
                    label={champ.label}
                    onChange={(e) => handleSetFieldValue(champ, e)}
                  ></TextField2>
                </div>
              ))}

            {block.name === "Formulaire consentement DPE" && (
              <div className="mt-2 w-c400">
                <div className="flex flex-col gap-2 text-h4">
                  <label
                    className={`p-3 rounded-lg border-2 cursor-pointer transition-all ${
                      consentGiven === true
                        ? "border-green-600 bg-green-50"
                        : "border-gray-300 bg-white hover:bg-gray-50"
                    }`}
                  >
                    <input
                      type="radio"
                      name="consent"
                      value="yes"
                      checked={consentGiven}
                      onChange={() => setConsentGiven(true)}
                      className="mr-2"
                    />
                    Oui, je consens à signer ce document.
                  </label>

                  <label
                    className={`p-3 rounded-lg border-2 cursor-pointer transition-all ${
                      consentGiven === false
                        ? "border-red-600 bg-red-50"
                        : "border-gray-300 bg-white hover:bg-gray-50"
                    }`}
                  >
                    <input
                      type="radio"
                      name="consent"
                      value="no"
                      checked={!consentGiven}
                      onChange={() => setConsentGiven(false)}
                      className="mr-2"
                    />
                    Non, je ne consens pas à signer ce document.
                  </label>
                </div>
              </div>
            )}
          </div>
          <div
            className={`flex  rounded-full w-fit   px-10 py-3 text-white font-medium
               bg-primary  cursor-pointer hover:shadow-lg`}
            onClick={() => setSignStep(3)}
          >
            Suivant
          </div>
        </div>
      )}
      {sign_step === 3 && sign_type === "inside" && (
        <div className="w-full mb-5 h-fit justify-center flex flex-col gap-4 my-4 items-center">
          {folderData.client_type === "particulier" && (
            <div className="flex flex-col gap-2">
              <div className="text-shadow_50 text-h2 font-semibold">
                Ajoutez vos initiales
              </div>
              <Space y={5}></Space>
              <div>
                <TextField2
                  value={sign_name}
                  label="A. B."
                  onChange={(e) => setSignName(e.target.value)}
                ></TextField2>

                <div
                  ref={textRef}
                  className=" bg-neutral-100 mt-4 alex-brush-regular "
                  style={{
                    fontSize: "50px",
                    color: "blue",
                    fontFamily: "Alex Brush",
                    textAlign: "center",
                  }}
                >
                  {sign_name}
                </div>
              </div>
            </div>
          )}
          <div
            className={`flex  rounded-full w-fit   px-10 py-3 text-white font-medium items-center
               bg-primary  cursor-pointer hover:shadow-lg`}
            onClick={handleSign}
          >
            Signer <SmallSpinner margin={6} loading={loadingConfirm} />
          </div>
        </div>
      )}
    </div>
  );
};

export default SignBlockFolder;

export const BackButton = ({ setSignStep, sign_type }) => {
  return (
    <div className="text-shadow_50 mt-4 text-h2 w-full gap-6  flex flex-row items-center ">
      <div
        className=" cursor-pointer flex flex-row items-center gap-2 bg-primary_l3 rounded-full w-fit px-2 py-1 h-fit hover:bg-white"
        onClick={() => setSignStep(0)}
      >
        <Icon1 icon_name="back" fill="rgba(81,83,242,1)" size={20}></Icon1>
        <div className="text-h3 font-semibold text-primary_l bg-transparent">
          Retour
        </div>
      </div>
      {sign_type === "outside" ? "Signature hors hexagone" : "Signature rapide"}
    </div>
  );
};
